import React from "react";

export const About = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/about.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>HAKKIMIZDA</h2>
              {props.data ? (
                <div dangerouslySetInnerHTML={{ __html: props.data.paragraph }} />
              ) : (
                <p>loading...</p>
              )}
              <h2>VİZYONUMUZ</h2>
              {props.data ? (
                <div dangerouslySetInnerHTML={{ __html: props.data.Vizyon }} />
              ) : (
                <p>loading...</p>
              )}
              <h2>MİSYONUMUZ</h2>
              {props.data ? (
                <div dangerouslySetInnerHTML={{ __html: props.data.Misyon }} />
              ) : (
                <p>loading...</p>
              )}
              <h2>DEĞERLERİMİZ</h2>
              <div className="list-style">
                <div className="col-lg-12 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Degerlerimiz.map((d, i) => (
                          <div key={`${i}`}>
                            {" "}
                            <h5> {d.baslik} </h5> {d.aciklama}
                          </div>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
